import React from "react";
import asyncComponent from "../helpers/AsyncFunc";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const routes = [
  {
    key: "page_example",
    path: "page_example",
    product: "app",
    component: asyncComponent(() => import("../pages/pageExample.js")),
    onMenu: true,
    label: "Page Example",
    leftIcon: <FontAwesomeIcon icon={["fal", "question-circle"]} />,
    permissions: ["dz.view.examples"],
  },
  {
    key: "dashboard",
    path: "dashboard",
    product: "app",
    component: asyncComponent(() => import("../pages/dashboard.js")),
    onMenu: true,
    label: "Dashboard",
    leftIcon: false,
    permissions: ["dz.view.dashboard"],
  },
  {
    key: "accounts",
    path: "accounts",
    product: "app",
    component: asyncComponent(() => import("../pages/accounts.js")),
    onMenu: true,
    label: "Accounts",
    leftIcon: false,
    permissions: ["dz.view.accounts"],
  },
  {
    key: "transactions",
    path: "transactions",
    product: "app",
    component: asyncComponent(() => import("../pages/transactions.js")),
    onMenu: true,
    label: "Transactions",
    leftIcon: false,
    permissions: ["dz.view.transactions"],
  },
  {
    key: "documents",
    path: "documents",
    product: "app",
    component: asyncComponent(() => import("../pages/documents.js")),
    onMenu: true,
    label: "Documents",
    leftIcon: false,
    permissions: ["dz.view.documents"],
  },
  {
    key: "contact_us",
    path: "contact_us",
    product: "app",
    component: asyncComponent(() => import("../pages/contactus.js")),
    onMenu: true,
    label: "Contact Us",
    leftIcon: false,
    permissions: ["dz.view.contactus"],
  },
];

export default routes;
